import Vue from 'vue'
import router from '../router'
import axios from 'axios'
import qs from 'qs'
import storage from '../common/storage'
import { Toast } from 'vant';
import { Dialog } from 'vant'
Vue.use(Toast, Dialog);
import util from '../common/util'

// axios默认配置
 var beseUrl = 'https://h5.liuantang.com.cn/app/gateway.php'
// var beseUrl = 'http://lat.com/app/gateway.php'
// var beseUrl = '//lat.com/app/gateway.php'

axios.defaults.baseURL = beseUrl
axios.defaults.timeout = 10000
axios.defaults.withCredentials = false

let data = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
}

axios.defaults.headers = data;

var authorApiArr = [

]

var CancelToken = axios.CancelToken;
var _cancel; // 用来保存终止axios请求函数
// 请求时的拦截
axios.interceptors.request.use(function (config) {
    var api = config.url.split("r=")[1]
    var useinfo = storage.s_getItem('useinfo') || {}
    authorApiArr.forEach(val=>{
        // 需要注册的接口
        if (api == val && !useinfo.mobile) {
            // 终止请求
            _cancel({ type: 'loading', duration: 100, message: '加载中...' })
            Dialog.confirm({ title: '提示', message: '请先前往注册再进行操作' })
            .then(() => {
                storage.s_setItem('beforeLoginUrl', router.history.current.fullPath)
                router.push('/register')
            }).catch(() => {
                // on cancel
            })
        }
    })
    return config
}, function (error) { // 当请求异常时做一些处理
    return Promise.reject('请求异常', error)
})
// 响应时拦截
axios.interceptors.response.use((res) => {
    if (res.status === 200) {
        Toast.loading({
            duration: 100,
            message: '加载中...'
        })
        if (res.data.error === 10001 ) {
            Toast('登录状态已失效，请从新登录')
            storage.s_clear() // 清空所有sessionStorage
            util.removeCookie('token')
            storage.s_setItem('beforeLoginUrl', router.history.current.fullPath) // 保存用户进入的url和参数（fullPath：url+参数）
            router.push('/author')
            return false
        } else if (res.data.error === -1) {
            Toast(res.data.message)
        }
        return Promise.resolve(res)
    } else {
        //Toast('系统异常！',res.status)
        return Promise.reject(res)
    }
}, (err) => {
    Toast(err.message)
    return Promise.reject(err)
})



// 封装http请求
export default function request(params) {
    Toast.loading({
        duration: 0,
        message: '加载中...'
    })
    params.url = beseUrl + '?i=' + 1 + '&r=' + params.url
    return new Promise((resolve, reject) => {
        var data = {}
        var datatype = ''
        if (!params.data) { params.data = {} }
        var mid = storage.s_getItem('member_id');
        params.data.mid = mid;

        let header = {};
        if(util.getCookie('token')) {header['X-TOKEN'] = util.getCookie('token')}
        params.data['token'] = util.getCookie('token') ? util.getCookie('token') : ""
        if (params.method && params.method==='get') {
            datatype = 'params'
            data = params.data
        } else {
            datatype = 'data'
            data = qs.stringify(params.data)
        }
        axios({
            method: params.method ? params.method : 'post',
            url: params.url,
            [datatype]: data,
            headers:header,
            // 设置 cancelToken
            cancelToken: new CancelToken(function executor(c){
                _cancel = c
            })
        }).then(res => {
            if (res.data.token){ util.setCookie('token', res.data.token, 2) } // 覆盖token
            resolve(res.data)
        }, err => {
            reject(err)
        }).catch((error) => {
            // Toast('系统异常！',error)
            reject(error)
        })
    })
}



// WEBPACK FOOTER //
// ./src/request/http.js